// src/admin/app/AdminDashboard.js
import React from 'react';
import { AdminLayout } from '../../containers/Layout';
import { AdminSideBar, AdminNavBar } from '../modules/AdminNavs';
import './admindashboard.scss';

function AdminDashboard() {
    return (
        <div className="admin-layout">
            <aside className="admin-aside">
                <AdminSideBar />
            </aside>
            
            <div className="admin-navbar">
                <AdminNavBar />
            </div>
            
            <main className="admin-main">
                <AdminLayout />
            </main>
        </div>
    );
}

export default AdminDashboard;
